import { convertStringArray, ParseQsValue } from 'modules/utils/queryString';
import { StoreType } from 'types/common';
import { STORE_DETAIL_URLS } from 'constants/marketplace/revenue';


export const ItemDetailUrl = ({ itemId, store }: { itemId: string; store: StoreType }): string =>
  `${STORE_DETAIL_URLS[store]}/${itemId}`;

export const parseStoreQueryString = (
  store: ParseQsValue,
  initialStore: StoreType[],
): StoreType[] => {
  return convertStringArray(store)?.map(store => Number(store)) ?? initialStore;
};
